import { render, staticRenderFns } from "./ReportAlertsManageWidget.vue?vue&type=template&id=8f1ed378&scoped=true&"
import script from "./ReportAlertsManageWidget.vue?vue&type=script&lang=js&"
export * from "./ReportAlertsManageWidget.vue?vue&type=script&lang=js&"
import style0 from "./ReportAlertsManageWidget.vue?vue&type=style&index=0&id=8f1ed378&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1ed378",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Betterway.vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f1ed378')) {
      api.createRecord('8f1ed378', component.options)
    } else {
      api.reload('8f1ed378', component.options)
    }
    module.hot.accept("./ReportAlertsManageWidget.vue?vue&type=template&id=8f1ed378&scoped=true&", function () {
      api.rerender('8f1ed378', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/ReportAlertsManageWidget.vue"
export default component.exports